import React, { useEffect } from 'react';
import { Route, BrowserRouter } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import * as Screens from '../../modules';
import StudentRoute from './StudentRoute';
import { Creators as validateUserTokenActions } from '@/domain/useCases/login/validateUserUseCase';
import { Creators as getPhotoActions } from '@/domain/useCases/getPhoto';
import AdminRoute from './AdminRoute';

const Main = () => {
  const dispatch = useDispatch();
  const onValidateToken = () => {
    dispatch(validateUserTokenActions.validateUserToken());
  };
  const { data, isValidToken, isLogOut, notRoles, isLoading, notEnrolled } =
    useSelector((state: any) => state.auth);

  const { data: profilePhoto } = useSelector(
    (state: any) => state.profilePhoto
  );
  const { isSimulator: isSimulatorMode } = useSelector(
    (state: any) => state.simulator
  );
  const hasSimulatorRole = data?.isSimulator;

  useEffect(() => {
    onValidateToken();
  }, []);
  // cuando isValidToken es true se llama a la foto y se almacena en el persist
  useEffect(() => {
    if (isValidToken && !profilePhoto)
      dispatch(getPhotoActions.getProfilePhoto());
    // cuando el token es válido llama a las configuraciones
    // if (isValidToken)
    // dispatch(getExternalSettings.getStudentPortalSettings());
  }, [isValidToken]);

  if (isLoading) {
    return <Screens.Splash />;
  }

  if (isLogOut) {
    return <Screens.Logout />;
  }

  if (notRoles) {
    return <Screens.DefaultPage />;
  }

  if (notEnrolled) {
    return <Screens.NotEnrolledPage />;
  }

  if (hasSimulatorRole && !isSimulatorMode) {
    return <AdminRoute />;
  }

  return (
    <BrowserRouter>
      <Route
        render={() => (isValidToken ? <StudentRoute /> : <Screens.Splash />)}
      />
    </BrowserRouter>
  );
};

export default Main;
